__turbopack_context__.v({
  "dragging": "formFileInput-module-scss-module__80c5fG__dragging",
  "fileInput": "formFileInput-module-scss-module__80c5fG__fileInput",
  "filled": "formFileInput-module-scss-module__80c5fG__filled",
  "icon": "formFileInput-module-scss-module__80c5fG__icon",
  "notFilled": "formFileInput-module-scss-module__80c5fG__notFilled",
});
